import { isCancelRequest } from '../../../configs/axios';
import { fetchAppsRequest } from '../api';
import { DEFAULT_APPS_FILTERS } from '../configs/constants';
import { syncFiltersToUrl } from './filters-actions';
import { FETCH_APPS_REQUEST, FETCH_APPS_SUCCESS, FETCH_APPS_FAILURE } from './actionTypes';

export const fetchApps =
  ({ metric, order, mode = 'replace' } = {}) =>
  (dispatch, getState) => {
    const { filters, apps } = getState();
    const isAppend = mode === 'append';

    const nextMetric = metric || apps.filters.metric;
    const nextOrder = order || apps.filters.order;
    const offset = isAppend ? apps.data.length : 0;
    const limit = isAppend
      ? DEFAULT_APPS_FILTERS.limit
      : Math.max(apps.data.length, DEFAULT_APPS_FILTERS.limit);

    dispatch({ type: FETCH_APPS_REQUEST, payload: { mode } });

    return fetchAppsRequest({
      ...filters,
      metric: nextMetric,
      order: nextOrder,
      offset,
      limit,
    })
      .then((data) => {
        dispatch({
          type: FETCH_APPS_SUCCESS,
          payload: {
            mode,
            data,
            filters: isAppend ? { offset } : { metric: nextMetric, order: nextOrder, offset: 0 },
          },
        });
        syncFiltersToUrl(getState());
      })
      .catch((error) => {
        if (isCancelRequest(error)) return;

        dispatch({ type: FETCH_APPS_FAILURE, payload: { error: error.message } });
      });
  };
